<script lang="ts">
	import Button from '$lib/buttons/v3/button.svelte';
	import Close from '$lib/icons/close.svelte';
	import Mill from '$lib/logos/mill.svelte';
	import { fly } from 'svelte/transition';
	import Image from './image.svelte';
	import type { SbImage, SbLink } from '../types';
	import { getSbUrl } from '$lib/utils/storyblok/url';
	import { scrollLock } from '$lib/utils/scrollLock.svelte';
	import type { ISbStoryData } from '@storyblok/js';
	import { onDestroy } from 'svelte';

	interface Props {
		navList: Array<ISbStoryData['content']>;
		signIn: ISbStoryData['content'];
		ctaImage?: SbImage;
		ctaLink?: SbLink;
		ctaTitle?: string;
		opens_overlay?: boolean;
		onoverlayopen?: () => void;
	}

	let {
		navList,
		signIn,
		ctaImage,
		ctaLink,
		ctaTitle,
		opens_overlay = false,
		onoverlayopen
	}: Props = $props();

	let show = $state(false);

	export function open() {
		show = true;
		scrollLock.lock();
	}

	export function close() {
		scrollLock.unlock();
		show = false;
	}

	onDestroy(() => {
		scrollLock.unlock();
	});
</script>

{#if show}
	<div
		transition:fly={{ x: '100%', opacity: 1 }}
		class="fixed inset-0 z-[70] flex flex-col justify-between bg-white p-5 text-brown-1"
		style="top: var(--banner-height);"
	>
		<div>
			<div class="flex items-center justify-between">
				<Mill class="h-8 text-green-3" />
				<Button onclick={close} class="btn-brown" title="Dismiss burger menu">
					<Close />
				</Button>
			</div>
			<nav class="flex flex-col gap-y-2 border-b-[0.5px] border-brown-5 py-8">
				{#each navList || [] as entry}
					<a class="py-2 text-[36px]/[112%] tracking-[-.36px]" href={getSbUrl(entry.link)}
						>{entry.title}</a
					>
				{/each}
			</nav>
			<div class="py-8">
				{#if signIn}
					<a class="text-[16px]/[104%] tracking-[-.16px]" href={getSbUrl(signIn.link)}
						>{signIn.title}</a
					>
				{/if}
			</div>
		</div>
		{#if ctaImage?.filename}
			<div class="relative max-w-[500px]">
				<Image
					src={ctaImage.filename}
					alt={ctaImage.alt}
					title={ctaImage.title}
					class="aspect-3/2 w-full rounded-2xl"
				/>

				<div class="absolute bottom-0 right-0 flex p-4">
					<Button
						class="btn-white"
						{...opens_overlay ? { onclick: onoverlayopen } : { href: getSbUrl(ctaLink) }}
					>
						{ctaTitle}
					</Button>
				</div>
			</div>
		{/if}
	</div>
{/if}
